import { useState } from "react";
import { Cpu, X } from "lucide-react";
import { PARTS, LAB_PARTS, partImg } from "@/lib/labParts";

export const RealParts = ({ labId }) => {
  const [open, setOpen] = useState(null);
  const keys = LAB_PARTS[labId] || [];
  const p = open && PARTS[open];
  return (
    <div className="rounded-3xl bg-white border border-slate-200 p-5 sm:p-6" data-testid="lab-real-parts">
      <h3 className="font-['Outfit'] font-extrabold text-xl text-[#0A192F] flex items-center gap-2"><Cpu className="w-5 h-5 text-[#007A8A]" />Real parts used in this project</h3>
      <p className="text-sm text-slate-500 mt-1">Actual components you'll handle in the RoboSpark lab. Tap any part to learn what it does.</p>
      <div className="mt-4 grid grid-cols-2 sm:grid-cols-3 gap-3">{keys.map((k) => (
        <button key={k} onClick={() => setOpen(k)} data-testid={`real-part-${k}`}
          className="group text-left rounded-2xl overflow-hidden border border-slate-200 bg-[#F4F7FC] hover:border-[#007A8A] hover:-translate-y-0.5 transition-[transform,border-color] duration-300">
          <div className="aspect-[4/3] overflow-hidden"><img src={partImg(k)} alt={PARTS[k][0]} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>
          <div className="p-3"><p className="font-bold text-sm text-[#0A192F] leading-tight">{PARTS[k][0]}</p><p className="text-xs text-slate-500 mt-0.5">{PARTS[k][1]}</p></div>
        </button>))}</div>
      {p && (
        <div className="fixed inset-0 z-[80] bg-[#0A192F]/70 backdrop-blur-sm grid place-items-center p-4" onClick={() => setOpen(null)} data-testid="real-part-modal">
          <div className="max-w-md w-full rounded-3xl bg-white overflow-hidden" onClick={(e) => e.stopPropagation()}>
            <img src={partImg(open)} alt={p[0]} className="w-full aspect-[4/3] object-cover" />
            <div className="p-5">
              <p className="font-['Outfit'] font-extrabold text-xl text-[#0A192F]" data-testid="real-part-modal-title">{p[0]}</p>
              <p className="text-sm font-semibold text-[#007A8A] mt-1">{p[1]}</p>
              <p className="text-slate-600 mt-2">{p[2]}.</p>
              <button onClick={() => setOpen(null)} className="mt-4 inline-flex items-center gap-1 rounded-full bg-[#0A192F] text-white px-5 py-2 text-sm font-bold" data-testid="real-part-modal-close"><X className="w-4 h-4" />Close</button>
            </div>
          </div>
        </div>)}
    </div>
  );
};
